import React, { useContext, useMemo, useState } from 'react';
import { BinStatusContext } from '../../../../../../context/BinStatusContext';
import { CompanyContext } from '../../../../../../context/CompanyContext';
import { BinStatus } from '../../../../../../types/bin';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../../types/translation/Translator';
import { BinStatusFilter } from '../../../../../../VentoryUI/components/filters/BinFilter';
import { CreateButton } from '../../../../../components/Button';
import { SearchFilter } from '../../../../../components/Filter';
import Table, { TableHeader } from '../../../../../components/Table';
import BinStatusLabel from '../../../../Common/BinStatusLabel';
import BinStatusModal from './BinStatusModal';

interface ModalProps {
  open: boolean;
  binStatus: BinStatus | undefined;
}

export default function BinStatusOverviewPane() {
  const { binStatuses } = useContext(BinStatusContext);
  const { currentCompany, companies } = useContext(CompanyContext);

  const allItems = useMemo(() => {
    return [...binStatuses.values()];
  }, [binStatuses]);

  const [items, setItems] = useState(allItems);
  const [modalProps, setModalProps] = useState<ModalProps>({ open: false, binStatus: undefined });

  const headers = useMemo(() => {
    const headers: TableHeader<BinStatus>[] = [];

    if (currentCompany.partner) {
      headers.push({
        key: 'company',
        name: translate({ key: TranslationKey.company }),
        text: (item: BinStatus) => companies.get(item.companyId)?.name || '',
      });
    }

    headers.push(
      ...[
        {
          key: 'status',
          name: translate({ key: TranslationKey.status }),
          text: (item: BinStatus) => item.status,
        },
        {
          key: 'status_label',
          name: '',
          text: (item: BinStatus) => {
            return <BinStatusLabel status={item} />;
          },
        },
      ],
    );

    return headers;
  }, [currentCompany, companies]);

  const filter = new BinStatusFilter();

  return (
    <>
      {modalProps.open && (
        <BinStatusModal
          open={modalProps.open}
          setOpen={open => setModalProps({ ...modalProps, open })}
          binStatus={modalProps.binStatus}
        />
      )}

      <div className='content-x flex h-full flex-col gap-8'>
        <div className='grid gap-2'>
          <p className='page-title'>{translate({ key: TranslationKey.binStatusOverviewPaneTitle })}</p>
          <p className='subtitle'>{translate({ key: TranslationKey.binStatusOverviewPaneSubtitle })}</p>
        </div>
        <div className='flex flex-grow flex-col gap-4'>
          <div className='flex justify-between gap-2'>
            <SearchFilter items={allItems} setItems={setItems} filter={filter} />
            <CreateButton onClick={() => setModalProps({ open: true, binStatus: undefined })} />
          </div>

          <Table
            items={items}
            headers={headers}
            filter={filter}
            onClick={binStatus => setModalProps({ open: true, binStatus })}
          />
        </div>
      </div>
    </>
  );
}
